<template>
<div id="pageDashboard">
    <v-container grid-list-xl fluid>
        <v-dialog v-model="deleteModal" persistent max-width="290">
            <v-card>
                <v-toolbar color="orange" dark small>
                    <v-toolbar-title>Delete </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark icon @click="deleteModal=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    Are you sure you want to delete this ?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="dark" small @click="deleteModal=false">
                        No
                    </v-btn>
                    <v-btn color="orange " class="white-text" small @click="deleteDoc">
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="duplicateDialog" persistent max-width="290">
            <v-card>
                <v-toolbar color="orange" dark small>
                    <v-toolbar-title>Duplicate </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark icon @click="duplicateDialog=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    Are you sure you want to duplicate this file ?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="dark" small @click="duplicateDialog=false">
                        No
                    </v-btn>
                    <v-btn color="orange " class="white-text" small @click="duplicateDocument">
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="deleteTabModal" persistent max-width="290">
            <v-card>
                <v-toolbar color="orange" dark small>
                    <v-toolbar-title>Delete </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark icon @click="deleteTabModal=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    Are you sure you want to delete this ?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="dark" small @click="deleteTabModal=false">
                        No
                    </v-btn>
                    <v-btn color="orange " class="white-text" small @click="deleteTabDoc">
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="shareAllBusinessDocsInfoDialog" persistent max-width="290">
            <v-card>
                <v-toolbar color="orange" dark small>
                    <v-toolbar-title></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark icon @click="shareAllBusinessDocsInfoDialog=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    By using the share all feature, you will be sharing all of your documents at once to the specified user. Would you like to continue?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="dark" small @click="shareAllBusinessDocsInfoDialog=false">
                        No
                    </v-btn>
                    <v-btn color="orange " class="white-text" small @click="shareAllBusinessDocs">
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="multiDeleteDialog" persistent max-width="290">
            <v-card>
                <v-toolbar color="orange" dark small>
                    <v-toolbar-title>Delete </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark icon @click="multiDeleteDialog=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    Are you sure you want to delete selected files ?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="dark" small @click="multiDeleteDialog=false">
                        No
                    </v-btn>
                    <v-btn color="orange " class="white-text" small @click="otherMyDocsDeleteFunc">
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog style="overflow-y:visible" v-model="shareUrlDialog" persistent max-width="450">
            <v-card>
                <v-toolbar color="orange" dark small>
                    <v-toolbar-title>Link to share document</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark icon @click="shareUrlDialog=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                        <div class="flex xs11 text-xs-left">
                            <div class="header text--darken-1" id="shareUrlPath">{{shareUrl}}</div>
                            <input type="hidden" id="shareUrlInput" :value="shareUrl" >
                            <v-progress-circular v-if="linkToShareLoadingIcon" indeterminate color="orange"></v-progress-circular>
                        </div>
                        <div class="flex xs1 text-xs-right">
                            <v-tooltip top>
                                <v-btn slot="activator" @click="copyToClipboard" class="remove-border" depressed outline icon fab dark color="orange" small>
                                    <v-icon size="30" class="main_ic" color="orange">assignment</v-icon>
                                </v-btn>
                                <span>Copy to clipboard</span>
                            </v-tooltip>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog style="overflow-y:visible" v-model="multiDocCopyToClipboardDialog" persistent max-width="450">
            <v-card>
                <v-toolbar color="orange" dark small>
                    <v-toolbar-title>Link to share document</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark icon @click="multiDocCopyToClipboardDialog=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                        <div class="flex xs11 text-xs-left">
                            <div class="header text--darken-1" id="shareMultiDocUrlPath">{{shareMultiUrl}}</div>
                            <input type="hidden" id="shareUrlSelectedInputId" :value="shareMultiUrl" >
                            <v-progress-circular v-if="linkToShareLoadingIcon" indeterminate color="orange"></v-progress-circular>
                        </div>
                        <div class="flex xs1 text-xs-right">
                            <v-tooltip top>
                                <v-btn slot="activator" @click="multiDocCopyToClipboard" class="remove-border" depressed outline icon fab dark color="orange" small>
                                    <v-icon size="30" class="main_ic" color="orange">assignment</v-icon>
                                </v-btn>
                                <span>Copy to clipboard</span>
                            </v-tooltip>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog style="overflow-y:visible" v-model="renameDialog" persistent max-width="450">
            <v-card>
                <v-toolbar color="orange" dark small>
                    <v-toolbar-title>Rename</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark icon @click="renameDialog=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-form v-on:submit.prevent data-vv-scope="renameForm" @submit.prevent="submitCitySearchForm()">
                    <v-card-text>
                        <v-text-field v-validate="{required: true,'restrictedWord':[]}" :error-messages="errors.collect('renameForm.name')"  name="name" label="Name" v-model="renameForm.name" data-vv-as="Name"></v-text-field>
                    </v-card-text>
                </v-form>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="gray white--text" small @click="renameDialog=false">
                        Cancel
                    </v-btn>
                    <v-btn color="green white--text" class="white-text" small @click="renameSubmit">
                        Submit
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog style="overflow-y:visible" v-model="inputEmailToShare" persistent max-width="600">
            <v-card>
                <v-toolbar color="orange" dark small>
                    <v-toolbar-title>Enter the recipients email</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark icon @click="inputEmailToShare=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-form v-on:submit.prevent data-vv-scope="shareWithEmail">
                    <v-card-text>
                        <v-text-field v-validate="{required: true, email:true,'restrictedWord':[]}" :error-messages="errors.collect('shareWithEmail.email')"  name="email" label="Email" v-model="shareForm.email" data-vv-as="Email"></v-text-field>
                    </v-card-text>
                </v-form>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="gray white--text" small @click="inputEmailToShare=false">
                        Cancel
                    </v-btn>
                    <v-btn color="green white--text" class="white-text" small @click="shareToEmail">
                        Submit
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog style="overflow-y:visible" v-model="addMoreDocs" persistent max-width="600">
            <v-card>
                <v-toolbar color="orange" dark small>
                    <v-toolbar-title>Add Another Document</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark icon @click="addMoreDocs=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-form v-on:submit.prevent data-vv-scope="addMoreDocsForm">
                    <v-card-text>
                        <v-text-field v-validate="{'required':true,'restrictedWord':[]}" :error-messages="errors.collect('addMoreDocsForm.doc_name')"  name="doc_name" label="Document Name" v-model="documentDefaultObj.doc_name" data-vv-as="Document Name"></v-text-field>
                    </v-card-text>
                    <v-card-text>
                        <v-flex lg12 md12 xs12>
                            <v-menu ref="picker_expiry_date"  
                            :close-on-content-click="false" 
                            v-model="documentDefaultObj.picker_expiry_date" 
                            transition="scale-transition" 
                            offset-y full-width 
                            :nudge-right="40" 
                            min-width="290px" 
                            :return-value.sync="documentDefaultObj.expiry_date">
                                <v-text-field 
                                class="custom-picker-text" 
                                id="expiry_date" 
                                v-validate="'required'" 
                                data-vv-name="expiry_date" 
                                data-vv-as="expiry Date" 
                                :error-messages="errors.collect('addMoreDocsForm.expiry_date')" 
                                slot="activator" 
                                label="Expiration Date *" 
                                :value="displayDate(documentDefaultObj.expiry_date)" 
                                prepend-icon="event" 
                                readonly></v-text-field>
                                <v-date-picker 
                                :min="minDate" 
                                v-model="documentDefaultObj.expiry_date" 
                                no-title scrollable 
                                @input="changePickerDate('expiry'); 
                                $refs.picker_expiry_date.save(documentDefaultObj.expiry_date)">
                                </v-date-picker>
                            </v-menu>
                        </v-flex>
                    </v-card-text>
                    <v-card-text>
                        <v-flex lg12 md12 customImgWrap>
                            <div class="customImgPopUp" id="file-drag-drop">
                                <form ref="myFiles">
                                    <v-icon>cloud_upload</v-icon><br>
                                    <p class="dragtxt">Drag files to upload</p>
                                    <p class="ortxt">Or</p>
                                    <v-btn slot="activator" color="orange darken- white--text" @click="$refs.inputUpload.click()">
                                        <v-icon>search</v-icon>&nbsp;&nbsp;CHOOSE FILE
                                    </v-btn>
                                    <input v-show="false"
                                        type="file" 
                                        id="file" 
                                        ref="inputUpload" 
                                        class="custom-file-input " 
                                        @change="onFileChange($event.target.files)"
                                    >
                                    <v-flex lg6 md12 xs12 v-if="fileValidationError" class="error-messages error--text text-xs-center">
                                        Please Select the File
                                    </v-flex>
                                    <p v-if="fileObj[0]">
                                        <strong class="link-text">     
                                            File selected to upload :
                                            <span>{{fileObj[0] ? fileObj[0].name : ''}}</span>
                                        </strong>
                                    </p>
                                </form>
                            </div>
                            <!-- <div class="customImg bgGray">
                                <v-icon>fa fa-upload</v-icon>
                                    <br>
                                    Click here to upload a file
                                    <br/>
                                <span class="link-text">
                                    <strong>
                                        {{fileObj[0] ? fileObj[0].name : ''}}
                                    </strong>
                                </span>
                            </div>                                
                                <input type="file" id="fileField" class="custom-file-input inputfilebutton" @change="onFileChange($event.target.files)">
                                <v-flex lg6 md12 xs12 v-if="fileValidationError" class="error-messages error--text">
                                    Please Select the File
                                </v-flex> -->
                        </v-flex>
                    </v-card-text>
                </v-form>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="gray white--text" small @click="addMoreDocs=false">
                        Cancel
                    </v-btn>
                    <v-btn color="green white--text" class="white-text" small @click="submitDocument">
                        Submit
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog style="overflow-y:visible" v-model="shareSelectedBusinessDocsDialog" persistent max-width="600">
            <v-card>
                <v-toolbar color="orange" dark small>
                    <v-toolbar-title>Document Sharing</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                        <v-btn slot="activator" @click="selectedBusinessDocsLink" class="remove-border" depressed outline icon fab dark small>
                            <i class="fas fa-link"></i>
                        </v-btn>
                        <span>Generate Link</span>
                    </v-tooltip>
                    <v-btn dark icon @click="shareSelectedBusinessDocsDialog=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-form v-on:submit.prevent data-vv-scope="shareMultipleDocsForm">
                    <v-card-text>
                        <v-flex lg12 md12 xs12 style="color:rgba(0,0,0,0.54);">
                            <h5>Select the documents you'd like to share via personalized email or link.</h5>
                        </v-flex>
                        <v-flex lg12 md12 xs12>
                        <div class="CustomScroll">
                            <v-data-table
                                v-model="selectedTruckerDocList"
                                :headers="docPopUpListHeader"
                                :items="listSelectedBussDocs"
                                select-all
                                hide-actions
                                item-key="uuid"
                                class="elevation-1" height="100"
                            >
                            <template v-slot:items="props">
                                <td>
                                <v-checkbox
                                    v-model="props.selected"
                                    :input-value="props.selected"
                                    primary
                                    hide-details
                                ></v-checkbox>
                                </td>
                                <td><strong>{{ props.item.doc_name }}</strong> - {{props.item.file_name}}</td>
                            </template>
                            </v-data-table>                            
                            </div>
                            <v-flex lg6 md12 xs12 v-if="multiDocValidationError" class="error-messages error--text">
                                The Document field is required
                            </v-flex>
                        </v-flex>
                        <v-flex xs12>
                            <v-combobox multiple
                                        v-model="multipleEmail" 
                                        name="shareMultipleDocsForm.email" 
                                        data-vv-as="Email"
                                        label="To" 
                                        append-icon
                                        chips
                                        deletable-chips
                                        class="tag-input"
                                        v-validate="{'required': true,'multiEmailValidate':[], 'maxMultiEmail':[]}"
                                        :error-messages="errors.collect('shareMultipleDocsForm.email')"
                                        :search-input.sync="multipleEmailSearch" 
                                        @keyup.tab="updateMultipleEmails"
                                        @paste="updateMultipleEmails"
                                        >
                            </v-combobox>
                        </v-flex>
                        <!--<v-flex xs12>
                            <v-text-field name="email" label="To" v-model="shareForm.email" data-vv-as="Email"></v-text-field>
                        </v-flex>-->
                        <v-flex xs12>
                            <v-text-field v-validate="{'restrictedWord':[]}" :error-messages="errors.collect('shareMultipleDocsForm.message')" name="message" label="Add a message (optional)" v-model="shareMultiDocForm.message" data-vv-as="Message"></v-text-field>
                        </v-flex>
                    </v-card-text>                    
                </v-form>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="gray white--text" small @click="shareSelectedBusinessDocsDialog=false">
                        Cancel
                    </v-btn>
                    <v-btn color="green white--text" class="white-text" small @click="shareSelectedToEmails">
                        Submit
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="addNewFolder" persistent max-width="600px">
            <v-card>
               <v-toolbar color="orange" dark small>
                    <v-toolbar-title>Create Folder</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark icon @click="addNewFolder = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                
                <v-form v-on:submit.prevent data-vv-scope="addNewFolderForm">
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field v-validate="{'required':true,'restrictedWord':[]}" :error-messages="errors.collect('addNewFolderForm.folder_name')"  name="folder_name" label="Folder Name" v-model="documentDefaultObj.folder_name" data-vv-as="Folder Name"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-form>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="gray  white--text" text @click="addNewFolder = false">
                        <v-icon color="white">fa-times-circle</v-icon> Cancel
                    </v-btn>
                    <v-btn color="green white--text" text @click="submitFolderForm">Save </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <v-toolbar card color="white">
            <v-toolbar-title>
                <h3>
                    Business Documents
                    <v-dialog v-model="documentInfoDialog" persistent max-width="500px">
                        <v-icon style="font-size: 16px; line-height: 2; position: absolute; top: 6px;" slot="activator">info</v-icon>
                        <v-card>
                            <v-card-title>
                                <span class="headline">Documents Info</span>
                            </v-card-title>
                            <v-card-text>
                                This is your personal storage space for your most used business documents. Upload your documents by clicking on the arrow icon and from there you will have the ability to save, share and delete the files. The files that are allowed to be uploaded are JPGs, PNGs, PDFs, GIFs, TXTs, DOCs, CSVs and XML Files. If you have any questions, feel free to call <a href="tel:18669256608">1.866.925.6608</a> to speak to a support representative.
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green white--text" text @click="documentInfoDialog = false">
                                    Ok
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </h3>
                <!--<span class="main_icon">
                    <v-tooltip top >
                    <v-icon @click="shareAllBusinessDocsInfo()" color="#ff812b" slot="activator">share </v-icon>
                        <span>Share all business documents</span>
                    </v-tooltip>
                </span>-->
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <v-layout wrap>
            <v-flex xs12>
                <v-tabs slider-color="orange">
                    <v-flex xs12>
                        <template v-if="truckerProfile && brokerProfile">
                            <v-tab key=0 @click="businsDocTabs('truckerProfile')">
                                <strong style="position:relative">Carrier</strong>                                    
                            </v-tab>
                            <v-tab key=1 @click="businsDocTabs('brokerProfile')">
                                <strong style="position:relative">Broker</strong>                                
                            </v-tab>
                            <v-tooltip style="position:absolute;left:200px;" top v-if="businsDocTabType == 'truckerProfile'">
                                <v-icon @click="shareSelectedBusinessDocs('truckerProfile')" color="#ff812b" slot="activator">share </v-icon>
                                <span>Share all documents</span>
                            </v-tooltip>
                            <v-tooltip style="position:absolute;left:200px;" top v-if="businsDocTabType == 'brokerProfile'">
                                <v-icon @click="shareSelectedBusinessDocs('brokerProfile')" color="#ff812b" slot="activator">share </v-icon>
                                <span>Share all documents</span>
                            </v-tooltip>
                        </template>
                        <template v-else>
                            <template v-if="truckerProfile">
                                <v-tab key=0 @click="businsDocTabs('truckerProfile')">
                                    <strong style="position:relative">Carrier</strong>                                    
                                </v-tab>
                                <v-tooltip style="position:absolute;" top v-if="businsDocTabType == 'truckerProfile'">
                                    <v-icon @click="shareSelectedBusinessDocs('truckerProfile')" color="#ff812b" slot="activator">share </v-icon>
                                    <span>Share all documents</span>
                                </v-tooltip>
                            </template>
                            <template v-if="brokerProfile">
                                <v-tab key=1 @click="businsDocTabs('brokerProfile')">
                                    <strong style="position:relative">Broker</strong>                                
                                </v-tab>
                                <v-tooltip style="position:absolute;" top v-if="businsDocTabType == 'brokerProfile'">
                                    <v-icon @click="shareSelectedBusinessDocs('brokerProfile')" color="#ff812b" slot="activator">share </v-icon>
                                    <span>Share all documents</span>
                                </v-tooltip>
                            </template>
                        </template>
                    </v-flex>
                    <v-tabs-items>
                        <template v-if="truckerProfile">
                            <v-tab-item key=0>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <ul class="card-list">
                                            <li>
                                                <div class="cardicon">
                                                    <v-card>
                                                        <v-menu offset-y v-if="W9.file_name">
                                                            <v-icon class="more_ic " slot="activator">more_vert</v-icon>
                                                            <v-list>
                                                                <template v-for="(action, index) in documentActions"  >
                                                                    <v-list-tile v-if="action.viewIn.includes('defaultBussDoc')" @click="" :key="index">
                                                                        <v-list-tile-title  @click="moreActions(action.action,W9)">{{ action.title }}</v-list-tile-title>
                                                                    </v-list-tile>
                                                                </template>
                                                            </v-list>
                                                        </v-menu>
                                                        <img :src="fileExtWithIcon[W9.file_name.split('.').pop()+'Icon']" class="custom-mt12" width="64px" v-if="W9.file_name" />
                                                        <!--<v-icon v-if="W9.file_name" class="main_ic custom-mt12">image</v-icon>-->
                                                        <div v-else class="customImgWrap">
                                                            <v-icon class="main_ic custom-mt12"> fa-arrow-circle-up </v-icon>
                                                            <input type="file" class="custom-file-input inputfilebutton" @change="onFileChange($event.target.files, 'W9')">
                                                        </div>
                                                        
                                                        <v-icon v-if="W9.file_name" class="status_ic" color="green">check_circle</v-icon>
                                                        <v-icon v-else class="status_ic" color="red">cancel</v-icon>
                                                    </v-card>
                                                    <h3>{{W9.doc_name}}</h3>
                                                    <v-tooltip top>
                                                        <span slot="activator"> {{W9.file_name ? utils.shortenLongStrings(W9.file_name,20) : needToUploadTxt}}</span>
                                                        <span>{{W9.file_name ? W9.file_name : needToUploadTxt}}</span>
                                                    </v-tooltip>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="cardicon">
                                                    <v-card>
                                                        <v-menu offset-y v-if="Insurance.file_name">
                                                            <v-icon class="more_ic " slot="activator">more_vert</v-icon>
                                                            <v-list>
                                                                <template v-for="(action, index) in documentActions"  >
                                                                    <v-list-tile v-if="action.viewIn.includes('defaultBussDoc')" @click="" :key="index">
                                                                        <v-list-tile-title @click="moreActions(action.action,Insurance)">{{ action.title }}</v-list-tile-title>
                                                                    </v-list-tile>
                                                                </template>
                                                            </v-list>
                                                        </v-menu>
                                                        <img :src="fileExtWithIcon[Insurance.file_name.split('.').pop()+'Icon']" class="custom-mt12" width="64px" v-if="Insurance.file_name" />
                                                        <!--<v-icon v-if="Insurance.file_name" class="main_ic custom-mt12">image</v-icon>-->
                                                        <div v-else class="customImgWrap">
                                                            <v-icon class="main_ic custom-mt12"> fa-arrow-circle-up </v-icon>
                                                            <input type="file" class="custom-file-input inputfilebutton" @change="onFileChange($event.target.files, 'Insurance')">
                                                        </div>
                                                        
                                                        <v-icon v-if="Insurance.file_name" class="status_ic" color="green">check_circle</v-icon>
                                                        <v-icon v-else class="status_ic" color="red">cancel</v-icon>
                                                    </v-card>
                                                    <h3>{{Insurance.doc_name}}</h3>
                                                    <v-tooltip top>
                                                        <span  slot="activator"> {{Insurance.file_name ? utils.shortenLongStrings(Insurance.file_name, 20) : needToUploadTxt}}</span>
                                                        <span>{{Insurance.file_name ? Insurance.file_name : needToUploadTxt}}</span>
                                                    </v-tooltip>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="cardicon">
                                                    <v-card>
                                                        <v-menu offset-y v-if="Authority.file_name">
                                                            <v-icon class="more_ic " slot="activator">more_vert</v-icon>
                                                            <v-list>
                                                                <template v-for="(action, index) in documentActions"  >
                                                                    <v-list-tile v-if="action.viewIn.includes('defaultBussDoc')" @click="" :key="index">
                                                                        <v-list-tile-title @click="moreActions(action.action,Authority)">{{ action.title }}</v-list-tile-title>
                                                                    </v-list-tile>
                                                                </template>
                                                            </v-list>
                                                        </v-menu>
                                                        <img :src="fileExtWithIcon[Authority.file_name.split('.').pop()+'Icon']" class="custom-mt12" width="64px" v-if="Authority.file_name" />
                                                        <!--<v-icon v-if="Authority.file_name" class="main_ic custom-mt12">image</v-icon>-->
                                                        <div v-else class="customImgWrap">
                                                            <v-icon class="main_ic custom-mt12"> fa-arrow-circle-up </v-icon>
                                                            <input type="file" class="custom-file-input inputfilebutton" @change="onFileChange($event.target.files, 'Authority')">
                                                        </div>
                                                        <v-icon v-if="Authority.file_name" class="status_ic" color="green">check_circle</v-icon>
                                                        <v-icon v-else class="status_ic" color="red">cancel</v-icon>
                                                    </v-card>
                                                    <h3>{{Authority.doc_name}}</h3>
                                                    <v-tooltip top>
                                                        <span slot="activator"> {{Authority.file_name ? utils.shortenLongStrings(Authority.file_name,20) : needToUploadTxt}}</span>
                                                        <span>{{Authority.file_name ? Authority.file_name : needToUploadTxt}}</span>
                                                    </v-tooltip>
                                                </div>  
                                            </li>

                                            <li v-for="(value, docIndex) in businessDocs.trucker" :key="docIndex">
                                                <div class="cardicon">
                                                    <v-card>
                                                        <v-menu offset-y v-if="value.file_name">
                                                            <v-icon class="more_ic " slot="activator">more_vert</v-icon>
                                                            <v-list>
                                                                <template v-for="(action, index) in documentActions"  >
                                                                    <v-list-tile v-if="action.viewIn.includes('addMoreBussDoc')" @click="" :key="index">
                                                                        <v-list-tile-title @click="moreActions(action.action,value, docIndex, 'trucker')">{{ action.title }}</v-list-tile-title>
                                                                    </v-list-tile>
                                                                </template>
                                                            </v-list>
                                                        </v-menu>
                                                        <img :src="fileExtWithIcon[value.file_name.split('.').pop()+'Icon']" class="custom-mt12" width="64px" />
                                                        <!--<v-icon class="main_ic custom-mt12">image</v-icon>-->
                                                        <v-icon class="status_ic" color="green">check_circle</v-icon>                        
                                                    </v-card>                            
                                                    <v-tooltip top>
                                                        <h3 slot="activator"> {{utils.shortenLongStrings(value.doc_name,20)}}</h3>
                                                        <span>{{value.doc_name}}</span>
                                                    </v-tooltip>
                                                    <v-tooltip top>
                                                        <span slot="activator"> {{utils.shortenLongStrings(value.file_name,20)}}</span>
                                                        <span>{{value.file_name}}</span>
                                                    </v-tooltip>
                                                </div>                 
                                            </li>
                                            <li>
                                                <div class="cardicon">
                                                    <v-card>
                                                        <v-icon @click="addMoreButton('business','file','trucker')" class="main_ic custom-mt12">add</v-icon>
                                                    </v-card>
                                                    <h3>Add More</h3>
                                                </div>
                                            </li>

                                        </ul>
                                    </v-flex>
                                </v-layout>
                            </v-tab-item>
                        </template>
                        <template v-if="brokerProfile">
                            <v-tab-item key=1>
                                <v-layout wrap >

                                    <v-flex xs12>
                                        <ul class="card-list">
                                            <li>
                                                <div class="cardicon">
                                                    <v-card>
                                                        <v-menu offset-y v-if="Contract1.file_name">
                                                            <v-icon class="more_ic " slot="activator">more_vert</v-icon>
                                                            <v-list>
                                                                <template v-for="(action, index) in documentActions"  >
                                                                    <v-list-tile v-if="action.viewIn.includes('defaultBussDoc')" @click="" :key="index">
                                                                        <v-list-tile-title @click="moreActions(action.action,Contract1)">{{ action.title }}</v-list-tile-title>
                                                                    </v-list-tile>
                                                                </template>
                                                            </v-list>
                                                        </v-menu>
                                                        <img :src="fileExtWithIcon[Contract1.file_name.split('.').pop()+'Icon']" class="custom-mt12" width="64px" v-if="Contract1.file_name" />
                                                        <!--<v-icon v-if="Contract1.file_name" class="main_ic">image</v-icon>-->
                                                        <div v-else class="customImgWrap">
                                                            <v-icon class="main_ic custom-mt12"> fa-arrow-circle-up </v-icon>
                                                            <input type="file" class="custom-file-input inputfilebutton" @change="onFileChange($event.target.files, 'Contract1')">
                                                        </div>
                                                        
                                                        <v-icon v-if="Contract1.file_name" class="status_ic custom-mt12" color="green">check_circle</v-icon>
                                                        <v-icon v-else class="status_ic" color="red">cancel</v-icon>
                                                    </v-card>
                                                    <h3>{{Contract1.doc_name}}</h3>
                                                    <v-tooltip top>
                                                        <span slot="activator"> {{Contract1.file_name ? utils.shortenLongStrings(Contract1.file_name,20) : needToUploadTxt}}</span>
                                                        <span>{{Contract1.file_name ? Contract1.file_name : needToUploadTxt}}</span>
                                                    </v-tooltip>
                                                </div> 
                                            </li>
                                            <li>
                                                <div class="cardicon">
                                                    <v-card>
                                                        <v-menu offset-y v-if="Contract2.file_name">
                                                            <v-icon class="more_ic " slot="activator">more_vert</v-icon>
                                                            <v-list>
                                                                <template v-for="(action, index) in documentActions"  >
                                                                    <v-list-tile v-if="action.viewIn.includes('defaultBussDoc')" @click="" :key="index">
                                                                        <v-list-tile-title @click="moreActions(action.action,Contract2)">{{ action.title }}</v-list-tile-title>
                                                                    </v-list-tile>
                                                                </template>
                                                            </v-list>
                                                        </v-menu>
                                                        <img :src="fileExtWithIcon[Contract2.file_name.split('.').pop()+'Icon']" class="custom-mt12" width="64px" v-if="Contract2.file_name" />
                                                        <!--<v-icon v-if="Contract2.file_name" class="main_ic custom-mt12">image</v-icon>-->
                                                        <div v-else class="customImgWrap">
                                                            <v-icon class="main_ic custom-mt12"> fa-arrow-circle-up </v-icon>
                                                            <input type="file" class="custom-file-input inputfilebutton" @change="onFileChange($event.target.files, 'Contract2')">
                                                        </div>
                                                        
                                                        <v-icon v-if="Contract2.file_name" class="status_ic" color="green">check_circle</v-icon>
                                                        <v-icon v-else class="status_ic" color="red">cancel</v-icon>
                                                    </v-card>
                                                    <h3>{{Contract2.doc_name}}</h3>
                                                    <v-tooltip top>
                                                        <span  slot="activator"> {{Contract2.file_name ? utils.shortenLongStrings(Contract2.file_name, 20) : needToUploadTxt}}</span>
                                                        <span>{{Contract2.file_name ? Contract2.file_name : needToUploadTxt}}</span>
                                                    </v-tooltip>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="cardicon">
                                                    <v-card>
                                                        <v-menu offset-y v-if="RateSheet.file_name">
                                                            <v-icon class="more_ic " slot="activator">more_vert</v-icon>
                                                            <v-list>
                                                                <template v-for="(action, index) in documentActions"  >
                                                                    <v-list-tile v-if="action.viewIn.includes('defaultBussDoc')" @click="" :key="index">
                                                                        <v-list-tile-title @click="moreActions(action.action,RateSheet)">{{ action.title }}</v-list-tile-title>
                                                                    </v-list-tile>
                                                                </template>
                                                            </v-list>
                                                        </v-menu>
                                                        <img :src="fileExtWithIcon[RateSheet.file_name.split('.').pop()+'Icon']" class="custom-mt12" width="64px" v-if="RateSheet.file_name" />
                                                        <!--<v-icon v-if="RateSheet.file_name" class="main_ic custom-mt12">image</v-icon>-->
                                                        <div v-else class="customImgWrap">
                                                            <v-icon class="main_ic custom-mt12"> fa-arrow-circle-up </v-icon>
                                                            <input type="file" class="custom-file-input inputfilebutton" @change="onFileChange($event.target.files, 'RateSheet')">
                                                        </div>
                                                        <v-icon v-if="RateSheet.file_name" class="status_ic" color="green">check_circle</v-icon>
                                                        <v-icon v-else class="status_ic" color="red">cancel</v-icon>
                                                    </v-card>
                                                    <h3>{{RateSheet.doc_name}}</h3>
                                                    <v-tooltip top>
                                                        <span slot="activator"> {{RateSheet.file_name ? utils.shortenLongStrings(RateSheet.file_name,20) : needToUploadTxt}}</span>
                                                        <span>{{RateSheet.file_name ? RateSheet.file_name : needToUploadTxt}}</span>
                                                    </v-tooltip>
                                                </div>
                                            </li>
                                            <li v-for="(value, docIndex) in businessDocs.brocker" :key="docIndex">
                                                <div class="cardicon">
                                                    <v-card>
                                                        <v-menu offset-y v-if="value.file_name">
                                                            <v-icon class="more_ic " slot="activator">more_vert</v-icon>
                                                            <v-list>
                                                                <template v-for="(action, index) in documentActions"  >
                                                                    <v-list-tile v-if="action.viewIn.includes('addMoreBussDoc')" @click="" :key="index">
                                                                        <v-list-tile-title @click="moreActions(action.action,value, docIndex, 'brocker')">{{ action.title }}</v-list-tile-title>
                                                                    </v-list-tile>
                                                                </template>
                                                            </v-list>
                                                        </v-menu>
                                                        <img :src="fileExtWithIcon[value.file_name.split('.').pop()+'Icon']" class="custom-mt12" width="64px" />
                                                        <!--<v-icon class="main_ic custom-mt12">image</v-icon>-->
                                                        <v-icon class="status_ic" color="green">check_circle</v-icon>                        
                                                    </v-card>
                                                    <v-tooltip top>
                                                        <h3 slot="activator"> {{utils.shortenLongStrings(value.doc_name,20)}}</h3>
                                                        <span>{{value.doc_name}}</span>
                                                    </v-tooltip>
                                                    <v-tooltip top>
                                                        <span slot="activator"> {{utils.shortenLongStrings(value.file_name,20)}}</span>
                                                        <span>{{value.file_name}}</span>
                                                    </v-tooltip>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="cardicon">
                                                    <v-card>
                                                        <v-icon @click="addMoreButton('business','file','brocker')" class="main_ic custom-mt12">add</v-icon>
                                                    </v-card>
                                                    <h3>Add More</h3>
                                                </div>
                                            </li>
                                        </ul>
                                    </v-flex>
                                </v-layout>
                            </v-tab-item>
                        </template>
                    </v-tabs-items>
                </v-tabs>
            </v-flex>
        </v-layout>    

        

        
        <v-layout wrap>
            <v-flex xs12>
                <v-tabs slider-color="orange">
                    <v-flex xs12>
                        <template>
                            <v-tab id="my_documents" key=0 @click="getDocumentList()"><strong>My Documents</strong></v-tab>
                        </template>
                        <template>
                            <v-tab key=1 @click="otherShareDocsTab('sent_document')"><strong>Sent Documents</strong></v-tab>
                        </template>
                        <template>
                            <v-tab key=2 @click="otherShareDocsTab('share_with_you')"><strong>Shared With You</strong></v-tab>
                        </template>
                    </v-flex>
                    <v-tabs-items class="bus_document_tab" slider-color="orange" touchless v-if="folderLevel == 0">
                        <template >
                            <v-tab-item key=0>
                                <v-card>
                                    <v-card-text class="pa-0 mt-2">
                                        <v-toolbar color="grey darken-1" dark>
                                            <v-flex xs12 md3 pa-0 text-left>
                                                <v-icon v-if="folderLevel > 0" class="more_ic" @click="getDocumentList()" slot="activator">fa-arrow-left</v-icon>
                                                <v-tooltip top>
                                                    <v-icon v-if="folderLevel == 0" class="more_ic" @click="newFolderDialog('others','folder')" slot="activator">add_circle_outline</v-icon>
                                                    <span>Create Folder</span>
                                                </v-tooltip>
                                            </v-flex>
                                            <v-flex xs12 md6 class="text-xs-center">
                                                {{folderDisplayName}}
                                            </v-flex>
                                            <v-flex xs12 md3 class="text-xs-right">
                                                <v-layout align-center justify-end row fill-height class="text-xs-right">
                                                    <!--<v-flex xs12 class="text-xs-right"> 9.25/10 Mb Available <v-icon>report</v-icon>
                                                    </v-flex>-->

                                                </v-layout>
                                            </v-flex>
                                        </v-toolbar>

                                        <v-data-table v-model="selected" select-all :headers="headers" :items="otherDocs" class="elevation-1" item-key="uuid">

                                            <!--<template v-slot:items="props">
                                                <tr>
                                                    
                                                    <th v-for="header in props.headers" 
                                                    :key="header.text" 
                                                    :class="['column sortable text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" 
                                                    @click="changeSort(header.value)"
                                                    >
                                                        <v-icon small>arrow_upward</v-icon>
                                                        {{ header.text }}
                                                    </th>
                                                    <th align="center">More</th>
                                                </tr>
                                            </template>-->
                                            <template v-slot:items="props">
                                                    <td>
                                                        <v-checkbox
                                                        v-model="props.selected"
                                                        primary
                                                        hide-details
                                                        ></v-checkbox>
                                                    </td>
                                                    <td>
                                                        {{ props.item.file_type }}
                                                    </td>
                                                    <td v-if="props.item.file_name">{{ props.item.file_name}} <strong>({{props.item.doc_name}})</strong></td>
                                                    <td v-else>
                                                        <a @click="folderClick(props.item)">{{ props.item.doc_name }}</a>
                                                    </td>
                                                    <td v-if="props.item.file_type == 'folder'">Created <strong>{{ props.item.created_at }}</strong></td>
                                                    <td v-else>Uploaded <strong>{{ props.item.created_at }} - {{ props.item.size / 1000 }}</strong> Kb</td>
                                                    <td>{{ props.item.file_type != 'folder' ?  props.item.expiry_date : '' }}</td>
                                                    <td>
                                                        <div class="text-xs-center">
                                                            <v-menu offset-y>
                                                                <template>
                                                                <v-icon class="more_ic" slot="activator">more_vert</v-icon>
                                                                </template>
                                                                <template v-for="(action,index) in documentActions" >
                                                                
                                                                    <v-list v-if="action.viewIn.includes('otherDoc') && action.forFiles.includes(props.item.file_type)" :key="index">    
                                                                        <v-list-tile  @click="moreActions(action.action,props.item, props.index, '')" >
                                                                            <v-list-tile-title>{{ action.title }}</v-list-tile-title>
                                                                        </v-list-tile>
                                                                    </v-list>
                                                                </template>
                                                            </v-menu>
                                                        </div>
                                                    </td>
                                            </template>
                                        </v-data-table>                                    
                                        <v-divider></v-divider>
                                        <div class="form-btn text-xs-right">
                                            <v-btn v-if="otherMyDocsDeleteBtn" @click="multiDeleteDialog=true" color="red white--text">Delete</v-btn>
                                            <v-btn @click="addMoreButton('others','file','')" color="orange white--text" slot="activator"> Upload </v-btn>
                                        </div>

                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                        </template>
                        <template>
                            <v-tab-item key=1>
                                <v-card>
                                    <v-card-text class="pa-0 mt-2">
                                        <v-toolbar color="grey darken-1" dark>
                                            <v-flex xs12 md3 pa-0 text-left>
                                                <v-icon v-if="folderLevel > 0" class="more_ic" @click="otherShareDocsTab('sent_document')" slot="activator">fa-arrow-left</v-icon>
                                            </v-flex>
                                            <v-flex xs12 md6 class="text-xs-center">
                                                {{folderDisplayName}}
                                            </v-flex>
                                        </v-toolbar>

                                        <v-data-table :pagination.sync="pagination" :disable-initial-sort="true" v-model="selected" select-all :headers="headersSentDoc" :items="sent_document" class="elevation-1" item-key="uuid">

                                            <template slot="headers" slot-scope="props">
                                                <tr>
                                                    <th v-for="header in props.headers" 
                                                    :key="header.text" 
                                                    :class="['column sortable text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" 
                                                    @click="changeSort(header.value)"
                                                    >
                                                        {{ header.text }}
                                                        <v-icon small>arrow_upward</v-icon>
                                                    </th>
                                                    <th align="center" class="text-xs-center">More</th>
                                                </tr>
                                            </template>
                                            <template slot="items" slot-scope="props">
                                                <tr :active="props.selected" @click="props.selected = !props.selected">
                                                    <td>
                                                        {{ props.item.file_type }}
                                                    </td>
                                                    <td v-if="props.item.file_name">{{ props.item.file_name}} <strong>({{props.item.doc_name}})</strong></td>
                                                    <td v-else>
                                                        <a @click="folderClick(props.item)">{{ props.item.doc_name }}</a>
                                                    </td>
                                                    <td v-if="props.item.file_type == 'folder'">Sent <strong>{{ props.item.shared_created_at }} </strong></td>
                                                    <td v-else>Sent <strong>{{ props.item.shared_created_at }} - {{ props.item.size / 1000 }} </strong> Kb</td>
                                                    <td>{{ props.item.email }}</td>
                                                    <td>{{ (props.item.file_type != 'folder' && props.item.document_type != 'business') ? props.item.expiry_date : '' }}</td>
                                                    <td>
                                                        <div class="text-xs-center">
                                                            <v-menu offset-y>
                                                                <template>
                                                                    <v-icon class="more_ic" slot="activator">more_vert</v-icon>
                                                                </template>
                                                                <template >
                                                                    <v-list>
                                                                        <v-list-tile  @click="moreActions('deleteTabDoc',props.item, props.index, '')" >
                                                                            <v-list-tile-title>Delete</v-list-tile-title>
                                                                        </v-list-tile>
                                                                    </v-list>
                                                                    <v-list>
                                                                        <v-list-tile  @click="moreActions('download',props.item, props.index, '')" >
                                                                            <v-list-tile-title>Download</v-list-tile-title>
                                                                        </v-list-tile>
                                                                    </v-list>
                                                                </template>
                                                            </v-menu>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                        </template>
                        <template>
                            <v-tab-item key=2>
                                <v-card>
                                    <v-card-text class="pa-0 mt-2">
                                        <v-toolbar color="grey darken-1" dark>
                                            <v-flex xs12 md3 pa-0 text-left>
                                                <v-icon v-if="folderLevel > 0" class="more_ic" @click="otherShareDocsTab('share_with_you')" slot="activator">fa-arrow-left</v-icon>
                                            </v-flex>
                                            <v-flex xs12 md6 class="text-xs-center">
                                                {{folderDisplayName}}
                                            </v-flex>
                                        </v-toolbar>

                                        <v-data-table :pagination.sync="pagination" :disable-initial-sort="true" v-model="selected" select-all :headers="headersSharedWithYou" :items="share_with_you" class="elevation-1" item-key="uuid">

                                            <template slot="headers" slot-scope="props">
                                                <tr>
                                                    <th v-for="header in props.headers" 
                                                    :key="header.text" 
                                                    :class="['column sortable text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" 
                                                    @click="changeSort(header.value)"
                                                    >
                                                        {{ header.text }}
                                                        <v-icon small>arrow_upward</v-icon>
                                                    </th>
                                                    <th align="center"  class="text-xs-center">More</th>
                                                </tr>
                                            </template>
                                            <template slot="items" slot-scope="props">
                                                <tr :active="props.selected" @click="props.selected = !props.selected">
                                                    <td>
                                                        {{ props.item.file_type }}
                                                    </td>
                                                    <td v-if="props.item.file_name">{{ props.item.file_name}} <strong>({{props.item.doc_name}})</strong></td>
                                                    <td v-else>
                                                        <a @click="folderClick(props.item)">{{ props.item.doc_name }}</a>
                                                    </td>
                                                    <td v-if="props.item.file_type == 'folder'">Shared <strong>{{ props.item.shared_created_at }} </strong></td>
                                                    <td v-else>Shared <strong>{{ props.item.shared_created_at }} - {{ props.item.size / 1000 }} </strong> Kb</td>
                                                    <td>{{ (props.item.file_type != 'folder' && props.item.document_type != 'business') ?  props.item.expiry_date : '' }}</td>
                                                    <td>{{ props.item.first_name }}</td>
                                                    <td>
                                                        <div class="text-xs-center">
                                                            <v-menu offset-y>
                                                                <template>
                                                                    <v-icon class="more_ic" slot="activator">more_vert</v-icon>
                                                                </template>
                                                                <template >
                                                                    <v-list>
                                                                        <v-list-tile  @click="moreActions('deleteTabDoc',props.item, props.index, '')" >
                                                                            <v-list-tile-title>Delete</v-list-tile-title>
                                                                        </v-list-tile>
                                                                    </v-list>
                                                                    <v-list>
                                                                        <v-list-tile  @click="moreActions('download',props.item, props.index, '')" >
                                                                            <v-list-tile-title>Download</v-list-tile-title>
                                                                        </v-list-tile>
                                                                    </v-list>
                                                                </template>
                                                            </v-menu>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                        </template>
                    </v-tabs-items>
                </v-tabs>
            </v-flex>            

        </v-layout>

       <v-layout v-if="folderLevel == 1">
            <v-flex>
                <v-card>
                    <v-card-text class="pa-0 mt-2">
                        <v-toolbar color="grey darken-1" dark>
                            <v-flex xs12 md3 pa-0 text-left v-if="otherTabType == 'mydocuments'">
                                <v-icon class="more_ic" @click="getDocumentList()" slot="activator">fa-arrow-left</v-icon>
                            </v-flex>
                            <v-flex xs12 md3 pa-0 text-left v-else>
                                <v-icon class="more_ic" @click="otherShareDocsTab(otherTabType)" slot="activator">fa-arrow-left</v-icon>
                            </v-flex>
                            <v-flex xs12 md6 class="text-xs-center">
                                {{folderDisplayName}}
                            </v-flex>
                        </v-toolbar>

                        <v-data-table :pagination.sync="pagination" :disable-initial-sort="true" v-model="selected" select-all :headers="headers" :items="otherDocs" class="elevation-1" item-key="uuid">
                            <template slot="headers" slot-scope="props">
                                <tr>
                                    <!--<th>
                                        <v-checkbox
                                        :input-value="props.all"
                                        :indeterminate="props.indeterminate"
                                        primary
                                        hide-details
                                        @click.native="toggleAll"
                                        ></v-checkbox>
                                    </th>-->
                                    <th v-for="header in props.headers" 
                                    :key="header.text" 
                                    :class="['column sortable text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" 
                                    @click="changeSort(header.value)"
                                    >
                                        <v-icon small>arrow_upward</v-icon>
                                        {{ header.text }}
                                    </th>
                                    <!--<th align="center">More</th>-->
                                </tr>
                            </template>
                            <template slot="items" slot-scope="props">
                                <tr :active="props.selected" @click="props.selected = !props.selected">
                                    <!--<td>
                                        <v-checkbox 
                                            :input-value="props.selected" 
                                            primary hide-details>
                                        </v-checkbox>
                                    </td>-->
                                    <td>
                                        {{ props.item.file_type }}
                                    </td>
                                    <td v-if="props.item.file_name">{{ props.item.file_name}} <strong>({{props.item.doc_name}})</strong></td>
                                    <td v-else>
                                        <a @click="folderClick(props.item)">{{ props.item.doc_name }}</a>
                                    </td>
                                    <td>Uploaded <strong>{{ props.item.created_at }} - {{ props.item.size / 1000 }}</strong> Kb</td>
                                    <td>{{ props.item.file_type != 'folder' ?  props.item.expiry_date : '' }}</td>
                                    <td>
                                        <div class="text-xs-center">
                                            <v-menu offset-y>
                                                <v-icon class="more_ic" slot="activator">more_vert</v-icon>
                                                    <v-list v-if="otherTabType == 'mydocuments'">    
                                                        <v-list-tile  @click="moreActions('delete',props.item, props.index, '')" >
                                                            <v-list-tile-title>Delete</v-list-tile-title>
                                                        </v-list-tile>
                                                    </v-list>
                                                    <v-list>    
                                                        <v-list-tile  @click="moreActions('download',props.item, props.index, '')" >
                                                            <v-list-tile-title>Download</v-list-tile-title>
                                                        </v-list-tile>
                                                    </v-list>
                                            </v-menu>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>                                    
                        <v-divider></v-divider>
                        <div class="form-btn text-xs-right" v-if="otherTabType == 'mydocuments'">
                            <v-btn @click="addMoreButton('others','file','')" color="orange white--text" slot="activator"> Upload </v-btn>
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>

</div>
</template>

<script>
import API from "@/api";
import VWidget from "@/components/VWidget";
import Material from "vuetify/es5/util/colors";
import axios from "axios";
import config from "../../config";
import utils from "../../util";
import services from "../../services/HttpService";
import GoogleAds from "@/pages/widgets/GoogleAds";
import UploadButton from 'vuetify-upload-button';
import { BitlyClient } from 'bitly';
import moment from 'moment';
import {Validator, ErrorBag} from 'vee-validate';
import SimpleCrypto from "simple-crypto-js";
const bitly = new BitlyClient('7ddfbffc48a0b885a080b3d317b62d5320cac6c3', {});
var JSZip = require("jszip");

Validator.extend('multiEmailValidate', {
    getMessage: field => "The "+field+" field must be a valid email",
    validate: async function (value) {
 
        let v = new Validator();
        // let emailsArr = value.split(',');
        let returnStatus = true;

        let resValid = await value.map(async function(email){
            let { valid, errors } = await v.verify(email.trim(),'email');
            return valid;
        });
        const numFruits = await Promise.all(resValid)
        return !numFruits.includes(false);
    }
});
Validator.extend('maxMultiEmail', {
    getMessage: field => "The "+field+" not allowed more than 8.",
    validate: async function (value) {
        if(value.length > 8){
            return false;
        }
        return true;
    }
});

export default {
    components: {
        VWidget,
        GoogleAds,
        'upload-btn': UploadButton
    },
    data() {
        return {
            W9: {
                uuid: '',
                user_uuid: '',
                document_type: 'business',
                file_type: 'file',
                folder_name:'',
                file_name: '',
                doc_name: 'W9',
                expiry_date:'',
                doc_url:'',
                base_level:0,
                size:0,
                user_type:'trucker'
            },
            Insurance: {
                uuid: '',
                user_uuid: '',
                document_type: 'business',
                file_type: 'file',
                folder_name:'',
                file_name: '',
                doc_name: 'Insurance',   
                expiry_date:'',    
                doc_url:'',
                base_level:0,
                size:0,
                user_type:'trucker'
            },
            Authority: {
                uuid: '',
                user_uuid: '',
                document_type: 'business',
                file_type: 'file',
                folder_name:'',
                file_name: '',
                doc_name: 'Authority',
                expiry_date:'',
                doc_url:'',
                base_level:0,
                size:0,
                user_type:'trucker'
            },
            Contract1: {
                uuid: '',
                user_uuid: '',
                document_type: 'business',
                file_type: 'file',
                folder_name:'',
                file_name: '',
                doc_name: 'Contract1',
                expiry_date:'',
                doc_url:'',
                base_level:0,
                size:0,
                user_type:'broker'
            },
            Contract2: {
                uuid: '',
                user_uuid: '',
                document_type: 'business',
                file_type: 'file',
                folder_name:'',
                file_name: '',
                doc_name: 'Contract2',   
                expiry_date:'',    
                doc_url:'',
                base_level:0,
                size:0,
                user_type:'broker'
            },
            RateSheet: {
                uuid: '',
                user_uuid: '',
                document_type: 'business',
                file_type: 'file',
                folder_name:'',
                file_name: '',
                doc_name: 'RateSheet',
                expiry_date:'',
                doc_url:'',
                base_level:0,
                size:0,
                user_type:'broker'
            },
            shareForm : {
                email:'',
            },
            shareMultiDocForm : {
                email:[],
                message:'',
            },
            renameForm : {
                name:'',
            },
            // addMoreDocsForm : {
            //     doc_name:'',
            //     file_name:'',
            // },
            moment: moment,
            documentInfoTxt: config.documentInfoTxt,
            needToUploadTxt: config.needToUploadTxt,
            clickToShareTxt: config.clickToShareTxt,            
            sentDocumentsLabel: config.sentDocumentsLabel,
            sharedWithYouLabel: config.sharedWithYouLabel,
            linkToShareLoadingIcon: false,
            showMenu: true,
            shareUrlDialog: false,
            renameDialog: false,
            duplicateDialog: false,
            addMoreDocs: false,
            inputEmailToShare: false,
            shareUrl: '',
            shareMultiUrl: '',
            fileObj: {},
            // fileField: {},
            documentDefaultObj: {
                uuid: '',
                user_uuid: '',
                document_type: '',
                file_type: '',
                folder_name:'',
                file_name: '',
                doc_name: '',
                expiry_date:'',
                doc_url:'',
                base_level:0,
                size:0,
                user_type:'',
                expiry_date: null,
                picker_expiry_date: false,
                message: false,
            },
            currentDialogModel: '',
            businessDocs: [],
            otherDocs: [],
            sent_document: [],
            share_with_you: [],
            documentInfoDialog: false,
            shareAllBusinessDocsInfoDialog: false,
            shareSelectedBusinessDocsDialog: false,
            dialog1: false,
            dialog2: false,
            checkbox: false,
            deleteModal: false,
            deleteTabModal: false,
            multiDeleteDialog: false,
            deleteAction: '',
            deleteDoc_name: '',
            deleteUuid: '',
            actionObj: {},
            indexValue: null,
            roleTypeName: '',
            brokerProfile: false,
            truckerProfile: false,
            fileValidationError: false,
            addNewFolder: false,
            folderLevel: 0,
            folderName: '',
            folderDisplayName: '',
            shareAll: false,
            otherMyDocsDeleteBtn: false,
            otherTabType: null,
            multiDocValidationError: false,
            multiDocCopyToClipboardDialog: false,
            businsDocTabType: '',
            allTruckerDocList: [],
            allBrockerDocList: [],
            multipleEmailSearch: '',
            listSelectedBussDocs: [],
            multipleEmail: [],
            documentActions: [
                {
                    title: 'Delete',
                    action:'delete',
                    viewIn:['defaultBussDoc','addMoreBussDoc','otherDoc'],
                    forFiles:['file','folder'],
                },
                {
                    title: 'Share',
                    action:'share',
                    viewIn:['defaultBussDoc','addMoreBussDoc','otherDoc'],
                    forFiles:['file','folder'],
                },
                {
                    title: 'Download',
                    action:'download',
                    viewIn:['defaultBussDoc','addMoreBussDoc','otherDoc'],
                    forFiles:['file','folder'],
                },
                {
                    title: 'Link to Share',
                    action:'link-to-share',
                    viewIn:['defaultBussDoc','addMoreBussDoc','otherDoc'],
                    forFiles:['file'],
                },
                {
                    title: 'Rename',
                    action:'rename',
                    viewIn:['addMoreBussDoc','otherDoc'],
                    forFiles:['file','folder'],
                },
                {
                    title: 'Duplicate',
                    action:'duplicate',
                    viewIn:['otherDoc'],
                    forFiles:['file'],
                },
            ],
            selected: [],
            selectedTruckerDocList: [],
            pagination: {
                sortBy: 'name'
            },
            docPopUpListHeader:[
                {
                    text:'Select All',
                    value:'',
                    align: 'left',
                    sortable: false
                }
            ],
            headers: [{
                    text: 'Type',
                    align: 'left',
                    value: 'file_type'
                },
                {
                    text: 'File/Folder Name',
                    align: 'left',
                    value: 'folder_with_file'
                },
                {
                    text: 'Details',
                    align: 'left',
                    value: 'Details',
                    sortable: false
                },
                {
                    text: 'Expires On',
                    align: 'left',
                    value: 'expiry_date'
                },
                {
                    text: 'More',
                    align: 'center',
                    value: '',
                    sortable: false
                }
            ],            
            headersSentDoc: [{
                    text: 'Type',
                    align: 'left',
                    value: 'file_type'
                },
                {
                    text: 'File/Folder Name',
                    align: 'left',
                    value: 'folder_with_file'
                },
                {
                    text: 'Details',
                    align: 'left',
                    value: 'Details',
                    sortable: false
                },
                {
                    text: 'Email',
                    align: 'left',
                    value: 'email'
                },
                {
                    text: 'Expires On',
                    align: 'left',
                    value: 'expiry_date'
                }
            ],            
            headersSharedWithYou: [{
                    text: 'Type',
                    align: 'left',
                    value: 'file_type'
                },
                {
                    text: 'File/Folder Name',
                    align: 'left',
                    value: 'folder_with_file'
                },
                {
                    text: 'Details',
                    align: 'left',
                    value: 'Details',
                    sortable: false
                },
                {
                    text: 'Expires On',
                    align: 'left',
                    value: 'expiry_date'
                },
                {
                    text: 'User Name',
                    align: 'left',
                    value: 'first_name'
                }
            ],            
            allowFileExtDoc : [ 'pdf', 'jpg', 'jpeg', 'png', 'gif', 'txt', 'doc', 'csv', 'xml'],
            fileExtWithIcon:{
                pdfIcon:'/static/icon/001-pdf.png',
                jpgIcon:'/static/icon/003-jpg.png',
                jpegIcon:'/static/icon/003-jpg.png',
                pngIcon:'/static/icon/004-png.png',
                txtIcon:'/static/icon/006-txt.png',
                docIcon:'/static/icon/002-doc.png',
                csvIcon:'/static/icon/005-csv.png',
                xmlIcon:'/static/icon/xml.png',
                gifIcon:'/static/icon/gif.png',
            }
        }
    },
    watch : {
        addMoreDocs(val){
            const self = this;
            self.$validator.reset('addMoreDocsForm'); 
            if(!val){
                self.fileValidationError = false;
                self.resetAllDynamicObj();
            } else {
                self.documentDefaultObj['doc_name'] = '';
                self.documentDefaultObj['file_name'] = '';
                self.documentDefaultObj['folder_name'] = '';
                self.activateDragAndDrop();
            }
        },
        deleteModal(val){
            const self = this;
            if(!val){
                self.resetAllDynamicObj();
            }
        },
        deleteTabModal(val){
            const self = this;
            if(!val){
                self.resetAllDynamicObj();
            }
        },
        addNewFolder(val){
            const self = this;
            if(!val){
                self.documentDefaultObj['folder_name'] = '';
                self.documentDefaultObj['doc_name'] = '';
                self.$validator.reset('addNewFolderForm'); 
                self.currentDialogModel = '';
                self.folderName = '';
            }
        },
        inputEmailToShare(val){
            const self = this;
            if(!val){
                self.shareForm['email'] = '';
                self.$validator.reset('shareWithEmail'); 
                self.currentDialogModel = '';
                self.shareAll = false;
                self.resetAllDynamicObj();                
            }
        },
        shareSelectedBusinessDocsDialog(val){
            const self = this;
            if(!val){
                self.selectedTruckerDocList = [];
                self.shareMultiDocForm['email'] = '';
                self.shareMultiDocForm['message'] = '';
                self.$validator.reset('shareMultipleDocsForm'); 
                self.multipleEmail = [];
                // self.checkMultiShareDocValidation(self.selectedTruckerDocList);
                self.multiDocValidationError = false;
            }
        },
        shareUrlDialog(val){
            const self = this;
            if(!val){
                self.shareUrl = '';
                self.$validator.reset('addNewFolderForm'); 
                self.currentDialogModel = '';
            }
        },
        renameDialog(val){
            const self = this;
            if(!val){
                self.renameForm.name = '';
                self.$validator.reset('renameForm'); 
                self.currentDialogModel = '';
                self.indexValue = null;
            }
        },
        duplicateDialog(val){
            const self = this;
            if(!val){
                self.actionObj = {};
            }
        },
        selected(val){
            const self = this;
            if(val.length > 0){
                self.otherMyDocsDeleteBtn = true;
            } else {
                self.otherMyDocsDeleteBtn = false;
            }
        },
        selectedTruckerDocList(val){
            const self = this;
            if(self.shareSelectedBusinessDocsDialog){
                self.checkMultiShareDocValidation(val);
            }            
        },
    },
    mounted() {
        const self = this;
        self.brokerProfile = self.$store.state.user.permissions.loads && self.$store.state.user.permissions.loads == 'all' ? true : false;
        self.truckerProfile = self.$store.state.user.permissions.trucks && self.$store.state.user.permissions.trucks == 'all' ? true : false;
        if(self.truckerProfile){
            self.businsDocTabType = 'truckerProfile';
        } else if(self.brokerProfile) {
            self.businsDocTabType = 'brokerProfile';
        }
        let downloadScript = document.createElement('script');
        downloadScript.setAttribute('type', 'text/javascript');
        downloadScript.setAttribute('src', '/static/js/download.js');
        document.head.appendChild(downloadScript);  
    },
    created() {
        const self = this;
        self.utils = utils;    
        self.getDocumentList();    
        // bitly
        // .shorten('https://github.com/tanepiper/node-bitly')
        // .then(function(result) {
        // })
        // .catch(function(error) {
        // });
    },
    computed: {
        minDate() {
            const today = new Date();
            return this.formatDate(today);
        },
    },
    methods: {
        shareAllBusinessDocsInfo() {
            const self = this;
            self.shareAllBusinessDocsInfoDialog=true; 
        },
        shareSelectedBusinessDocs(type) {
            const self = this;
            if(type == 'truckerProfile'){
                self.listSelectedBussDocs = self.allTruckerDocList;
            }
            if(type == 'brokerProfile'){
                self.listSelectedBussDocs = self.allBrockerDocList;
            }
            self.shareSelectedBusinessDocsDialog=true; 
        },
        updateMultipleEmails() {
            this.$nextTick(() => {
                    this.multipleEmail.push(...this.multipleEmailSearch.split(","));
                    this.$nextTick(() => {
                        this.multipleEmailSearch = "";
                });
            });
        },
        shareAllBusinessDocs() {
            const self = this;
            self.shareAllBusinessDocsInfoDialog=false; 
            self.inputEmailToShare=true; 
            self.shareAll=true
        },
        resetAllDynamicObj (){
            const self = this;
            self.documentDefaultObj['doc_name'] = '';
            self.documentDefaultObj['file_name'] = '';
            self.documentDefaultObj['folder_name'] = '';
            self.fileObj = {};
            // document.getElementById("fileField").value = "";
            self.fileValidationError = false;
            self.documentDefaultObj['picker_expiry_date'] = false;
            self.documentDefaultObj['expiry_date'] = null;
            self.currentDialogModel = '';
        },
        otherShareDocsTab (val){
            const self = this,
            wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            self.otherTabType = val;
            self.folderLevel = 0;
            self.folderName = '';
            self.folderDisplayName = '';
            
            let qString = '?list_type='+val;
            services
            .get("documents/shared-list"+qString, {
                Authorization: "Bearer " + this.$store.state.user.token
            })
            .then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });

                if(res.data.data){
                    self[val] = res.data.data;
                } else {
                    self[val] = [];
                }
                if(self[val].length > 0 ){
                    self[val].map(function(value, index){
                        if(value.file_type == 'folder'){
                            self[val][index]['folder_with_file'] = value.doc_name;
                        } else {
                            self[val][index]['folder_with_file'] = value.file_name;
                        }                       
                        self[val][index]['expiry_date'] = (moment(value.expiry_date).format("YYYY") == '0001') ? null : moment(value.expiry_date).format("MMM DD, YYYY");
                        self[val][index]['shared_created_at'] = (moment(value.shared_created_at).format("YYYY") == '0001') ? null : moment(value.shared_created_at).format("MMM DD, YYYY HH:mm");
                    });
                }

            })
            .catch(err => {
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, "red");
            });

        },
        formatDate(date) {
            let month = `${date.getMonth() + 1}`;
            let day = `${date.getDate()}`;
            const year = date.getFullYear();
            if (month.length < 2) month = `0${month}`;
            if (day.length < 2) day = `0${day}`;
            return [year, month, day].join('-');folder_with_file
        },
        changeSort (column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } else {
                this.pagination.sortBy = column
                this.pagination.descending = false
            }
        },
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        makeBussObjectRoleWise(){
            const self = this;
            self.allTruckerDocList = [];
            if(self.W9.file_name){
                self.allTruckerDocList.push(self.W9);
            }
            if(self.Insurance.file_name){
                self.allTruckerDocList.push(self.Insurance);
            }
            if(self.Authority.file_name){
                self.allTruckerDocList.push(self.Authority);
            }

            if(self.businessDocs['trucker']){
                self.allTruckerDocList = self.allTruckerDocList.concat(self.businessDocs['trucker']);
            }

            self.allBrockerDocList = [];
            if(self.Contract1.file_name){
                self.allBrockerDocList.push(self.Contract1);
            }
            if(self.Contract2.file_name){
                self.allBrockerDocList.push(self.Contract2);
            }
            if(self.RateSheet.file_name){
                self.allBrockerDocList.push(self.RateSheet);
            }

            if(self.businessDocs['brocker']){
                self.allBrockerDocList = self.allBrockerDocList.concat(self.businessDocs['brocker']);
            }
        },
        getDocumentList(docObj){
            const self = this,
                wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            let qString = '';
            if(docObj){
                if(self.otherTabType == 'mydocuments'){
                    qString += '?uuid='+docObj.uuid;    
                } else {
                    qString += '?uuid='+docObj.doc_uuid;
                    if(docObj.document_type == "business"){
                        qString += "&is_business_doc="+true
                    }
                }                
                self.folderName = docObj.folder_name;
                self.folderDisplayName = docObj.doc_name;
            } else {
                self.otherTabType = 'mydocuments';
                self.folderLevel = 0;
                self.folderName = '';
                self.folderDisplayName = '';
            }
            axios.all([
                services.get("documents/list"+qString, {
                    'Authorization': 'Bearer ' + this.$store.state.user.token
                })            
            ])
            .then(axios.spread(function (documents) {
                wApp.$emit("showLoader", {
                    show: false
                });

                if(!docObj){

                }
                if (documents.data.data.bussinessDocs) {
                    self.businessDocs = [];
                    documents.data.data.bussinessDocs.map(function (data) {
                        if(data.file_name && typeof self[data.doc_name] != 'undefined'){
                            self[data.doc_name] = data;
                        } else {
                            if(typeof self.businessDocs[data.user_type] == 'undefined'){
                                self.businessDocs[data.user_type] = [];
                            }
                            self.businessDocs[data.user_type].push(data);
                        }
                    })
                }
                self.makeBussObjectRoleWise();
                self.otherDocs = [];
                let otherDocTempArr = [];
                otherDocTempArr = documents.data.data.otherDocs;
                // if(self.otherTabType == 'mydocuments'){
                    
                // } else {
                //     qString += '?uuid='+docObj.doc_uuid;
                // } 
                // if(documents.data.data.otherDocs){
                //     self.otherDocs = documents.data.data.otherDocs;
                //     // if(self.otherTabType == 'mydocuments'){
                //     //     qString += '?uuid='+docObj.uuid;    
                //     // } else {
                //     //     qString += '?uuid='+docObj.doc_uuid;
                //     // } 
                // } else {
                //     self.otherDocs = [];
                // }
                if(otherDocTempArr && otherDocTempArr.length > 0 ){
                    otherDocTempArr.map(function(value, index){
                        if(value.file_type == 'folder'){
                            otherDocTempArr[index]['folder_with_file'] = value.doc_name;
                        } else {
                            otherDocTempArr[index]['folder_with_file'] = value.file_name;
                        }
                        otherDocTempArr[index]['expiry_date'] =  (moment(value.expiry_date).format("YYYY") == '0001') ? null : moment(value.expiry_date).format("MMM DD, YYYY");
                        otherDocTempArr[index]['created_at'] =  (moment(value.created_at).format("YYYY") == '0001') ? null : moment(value.created_at).format("MMM DD, YYYY");
                    });
                    if(self.otherTabType == 'mydocuments' || self.folderLevel == 1){
                        self.otherDocs = otherDocTempArr;
                    } else if(self.otherTabType == 'sent_document'){
                        self['sent_document'] = otherDocTempArr;
                    } else if(self.otherTabType == 'share_with_you'){
                        self['share_with_you'] = otherDocTempArr;
                    }
                } else {
                    if(self.otherTabType == 'mydocuments'){
                        self.otherDocs = [];
                    } else if(self.otherTabType == 'sent_document'){
                        self['sent_document'] = [];
                    } else if(self.otherTabType == 'share_with_you'){
                        self['share_with_you'] = [];
                    }
                }
            }))
            .catch(function (err) {
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, config.errMsgColorStr);
            });
        },
        toggleAll () {
            if (this.selected.length) this.selected = []
            else this.selected = this.otherDocs.slice()            
        },
        toggleAllDocTruckerList () {
            if (this.selectedTruckerDocList.length) this.selectedTruckerDocList = []
            else this.selectedTruckerDocList = this.allTruckerDocList.slice()
        },
        showDeleteModal (){
            const self = this;
            self.deleteModal = true;            
        },
        showDeleteTabModal (){
            const self = this;
            self.deleteTabModal = true;            
        },
        copyToClipboard (){
            const self = this;
            let aa = document.querySelector('#shareUrlInput')
            aa.setAttribute('type', 'text')
            aa.select();
            document.execCommand("copy");
            aa.setAttribute('type', 'hidden')
            self._showToast('Document url copied');
        },
        submitFolderForm (){
            const self = this;
            let filesObj = new FormData();
            self.$validator.validateAll('addNewFolderForm')
                .then(isValid => {
                    if(isValid){
                        for (var key in self.documentDefaultObj) {
                            if (self.documentDefaultObj.hasOwnProperty(key)) {                                
                                filesObj.append(key, self.documentDefaultObj[key]);
                            }
                        }
                        self.uploadBusinessDoc(filesObj);
                    }
                })
        },
        submitDocument (doc_name){
            const self = this;
            let filesObj = new FormData();
            self.fileValidationError = false;
            if(typeof self[doc_name] != 'undefined'){

                let docVar = Object.assign({},self[doc_name]);
                docVar['file_name'] = self.fileObj[0].name;
                for (var key in docVar) {
                    if (docVar.hasOwnProperty(key)) {
                        filesObj.append(key, docVar[key]);
                    }
                }
                filesObj.append("file", self.fileObj[0]);
                filesObj.set("size", self.fileObj[0].size);
                self.uploadBusinessDoc(filesObj);
            } else {
                
                self.$validator.validateAll('addMoreDocsForm')
                    .then(isValid => {
                        if(typeof self.fileObj[0] == 'undefined'){
                            self.fileValidationError = true;
                        } else if(isValid){
                            for (var key in self.documentDefaultObj) {
                                if (self.documentDefaultObj.hasOwnProperty(key)) {
                                    filesObj.append(key, self.documentDefaultObj[key]);
                                }
                            }
                            if(self.folderName != ''){
                                filesObj.set("folder_name", self.folderName);
                                filesObj.set("base_level", 1);
                            }
                            filesObj.append("file", self.fileObj[0]);
                            filesObj.set("file_name", self.fileObj[0].name);
                            filesObj.set("size", self.fileObj[0].size);
                            // self.documentDefaultObj.file_name = self.fileObj[0].name;
                            self.uploadBusinessDoc(filesObj);
                        }
                    })
                
            }
            
        },
        addMoreButton (document_type, file_type, user_type){
            const self = this;
            self.documentDefaultObj.document_type = document_type;
            self.documentDefaultObj.file_type = file_type;
            self.documentDefaultObj.user_type = user_type;
            self.addMoreDocs = true;
            self.fileObj = {};
            self.currentDialogModel = 'addMoreDocs';
        },
        deleteDoc(){
            
            const self = this,
            wApp = window.getApp;

            let uuid = self.actionObj.uuid;
            wApp.$emit("showLoader", {
                show: true
            });
            services.delete("documents/delete", {uuid:uuid}, {
                'content-type': 'multipart/form-data',
                "Authorization": "Bearer " + self.$store.state.user.token
            })
            .then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });
                if (!res.data.is_error) {
                    if(typeof self[self.actionObj.doc_name] != 'undefined'){
                        self[self.actionObj.doc_name]['file_name'] = '';
                        self[self.actionObj.doc_name]['doc_url'] = '';
                    } else {

                        if(self.actionObj['document_type'] === 'others'){                            
                            self.otherDocs.splice(self.indexValue, 1);
                        } else if(self.actionObj['document_type'] === 'business'){
                            self.businessDocs[self.roleTypeName].splice(self.indexValue, 1);
                        }
                    }
                    self.deleteModal = false;  
                    self.indexValue = null;
                    self._showToast(res.data.message);
                    // self.getDocumentList();
                    document.getElementById("my_documents").getElementsByTagName('a')[0].click();
                } else {
                    self._showToast(res.data.message, "red");
                }
            })
            .catch(err => {
                self.deleteModal = false;  
                wApp.$emit("showLoader", {
                    show: false
                });
                if(typeof self[self.actionObj.doc_name] != 'undefined'){
                    // self[self.actionObj.doc_name]['file_name'] = '';
                    // self[self.actionObj.doc_name]['doc_url'] = '';
                } else {
                    // self.businessDocs.splice(self.indexValue, 1);
                }
                self._showToast(err.message, "red");
            });

        },
        deleteTabDoc(){

            const self = this,
            wApp = window.getApp;

            let uuid = self.actionObj.uuid;
            wApp.$emit("showLoader", {
                show: true
            });
            services.delete("documents/shared-delete", {uuid:uuid, delete_type:self.otherTabType}, {
                'content-type': 'multipart/form-data',
                "Authorization": "Bearer " + self.$store.state.user.token
            })
            .then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });
                if (res.status === 200) {
                    self[self.otherTabType].splice(self.indexValue, 1);
                    self.deleteTabModal = false;  
                    self.indexValue = null;
                    self._showToast(res.data.message);
                } else {
                    self._showToast(res.data.message, "red");
                }
            })
            .catch(err => {
                self.deleteTabModal = false;  
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, "red");
            });

        },
        otherMyDocsDeleteFunc(){

            const self = this,
            wApp = window.getApp;

            let uuid = self.actionObj.uuid;
            wApp.$emit("showLoader", {
                show: true
            });
            self.multiDeleteDialog = false;
            let result = self.selected.map(a => a.uuid).join();
            services.post("documents/multiple-delete", {uuids:result}, {
                "Authorization": "Bearer " + self.$store.state.user.token
            })
            .then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });
                if (res.status === 200) {
                    self._showToast(res.data.message);
                    self.getDocumentList();  
                } else {
                    self._showToast(res.data.message, "red");
                }
            })
            .catch(err => {
                self.deleteTabModal = false;  
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, "red");
            });

        },
        moreActions(action,docObj, indexValue, roleTypeName){
            const self = this,
            wApp = window.getApp;
            // self.actionObj = self.documentDefaultObj;
            self.actionObj = docObj;
            if(action == 'download'){
                wApp.$emit("showLoader", {
                    show: true
                });
                if(docObj.file_type == "folder"){
                    let qString = '';
                    if(self.otherTabType != 'mydocuments'){
                        qString += '?uuid='+docObj.doc_uuid;
                    } else {
                        qString += '?uuid='+docObj.uuid;
                    }
                    if(docObj.document_type == "business"){
                        qString += "&is_business_doc="+true
                    }
                    services.get("documents/list"+qString, {
                        'Authorization': 'Bearer ' + this.$store.state.user.token
                    })
                    .then(async function (documents) {
                        if(documents.data.data && documents.data.data.otherDocs && documents.data.data.otherDocs.length > 0){
                            let returnData = new Array();
                            var zip = new JSZip();
                            axios.all(
                                await documents.data.data.otherDocs.map(async function(document){
                                    await services.post("documents/download",
                                        {doc_path:document.doc_url}, 
                                        {"Authorization": "Bearer " + self.$store.state.user.token})
                                    .then(async res => {
                                        if (res.status === 200) {
                                            await zip.file(document.file_name,res.data.documentEncrypted,{base64: true});
                                        }
                                    })
                                })
                            ).then(axios.spread(function(response){
                                zip.generateAsync({type:"base64"}).then(async function(content) {
                                    await download('data:application/zip;base64,'+content,docObj.doc_name+'.zip');  
                                });
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                self._showToast(config.documentDownloadSuccessMsg,config.successMsgColorStr);
                            }));
                        }else{
                            wApp.$emit("showLoader", {
                                show: false
                            });
                            self._showToast('Empty Document', config.errMsgColorStr);
                        }
                    })
                    .catch(function (err) {
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        self._showToast(err.message, config.errMsgColorStr);
                    });
                }else{
                    services.post("documents/download",
                        {doc_path:docObj.doc_url}, 
                        {"Authorization": "Bearer " + this.$store.state.user.token})
                    .then(async res => {
                        wApp.$emit("showLoader", {
                            show: false
                        });
                    if (res.status === 200) {
                            await download('data:application/octet-stream;base64,'+res.data.documentEncrypted,docObj.file_name);
                            self._showToast(res.data.message, config.successMsgColorStr);
                        } else {
                            self._showToast(res.data.message, config.errMsgColorStr);
                        }
                    })
                    .catch(err => {
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        self._showToast(err.message, config.errMsgColorStr);
                    });
                }
            } else if(action == 'delete'){
                
                if(typeof self[self.actionObj.doc_name] != 'undefined'){
                    // action for default docs w9, authority and Insurance
                } else {
                    self.indexValue = indexValue;
                    self.roleTypeName = roleTypeName;
                }
                self.showDeleteModal();                
            } else if(action == 'deleteTabDoc'){
                
                self.indexValue = indexValue;
                self.showDeleteTabModal();

            } else if(action == 'share'){
                self.inputEmailToShare = true;
                if(typeof self[self.actionObj.doc_name] != 'undefined'){
                    self.documentDefaultObj = Object.assign({},docObj);
                } else {
                    self.documentDefaultObj = Object.assign({},docObj);
                } 
            } else if(action == 'link-to-share'){
                self.shareUrlDialog = true;
                self.linkToShareLoadingIcon = true;
                let shareLongUrl = config.storageBucketUrl+ docObj.doc_url;

                bitly
                .shorten(shareLongUrl)
                .then(function(result) {
                    self.linkToShareLoadingIcon = false;
                    self.shareUrl = result.url;
                })
                .catch(function(error) {
                    console.log(error);
                    self.linkToShareLoadingIcon = false;
                    self.shareUrlDialog = false;
                    self._showToast('Something is wrong, Please try again later', "red");
                });
                
            } else if(action == 'rename'){
                self.renameDialog = true;
                self.indexValue = indexValue;
            } else if(action == 'duplicate'){
                self.duplicateDialog = true;
            }
        },
        duplicateDocument(){
            const self = this,
            wApp = window.getApp;

            wApp.$emit("showLoader", {
                show: true
            });
            let requestObj = {} 
            requestObj.uuid = self.actionObj.uuid;
            services.post('documents/copy-file', requestObj, 
            {
                Authorization: "Bearer " + this.$store.state.user.token
            })
            .then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });
                self.getDocumentList();
                self.duplicateDialog = false;
                if(!res.data.is_error){
                    self._showToast(res.data.message);
                } else {
                    self._showToast(res.data.message);
                }
            })
            .catch(err => {
                wApp.$emit("showLoader", {
                    show: false
                });
                self.duplicateDialog = false;
                self._showToast(err.message, config.errMsgColorStr);
            });
        },
        onFileChange(file, type) {
            const self = this;
            self.fileObj = {};
            if(file.length > 0){
                self.fileValidations(file,function(res){
                    if(res){
                        self.fileObj = file;
                    }
                });
                if(typeof type != 'undefined'){
                    self.submitDocument(type);
                }
            }
        },
        fileValidations(file, cb){
            const self = this;
            let fileExtension = file[0].name.split('.').pop();
            if(file[0].size >= 5000000){
                self._showToast('File should be less than 5MB', "red");
                cb(false);
            } else if(!self.allowFileExtDoc.includes(fileExtension.toLowerCase())){
                self._showToast('Incorrect File Format!', "red");
                cb(false);
            } else {
                cb(true);
            }            
        },
        uploadBusinessDoc(filesObj) {
            
            const self = this,
            wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            let doc_name = filesObj.get('doc_name');

            services.postFile("documents/upload-document", filesObj, {
                    'content-type': 'multipart/form-data',
                    "Authorization": "Bearer " + self.$store.state.user.token
                })
                .then(res => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    if (!res.data.is_error) {
                        self.getDocumentList();
                        // if(self[doc_name] && typeof self[doc_name] != 'undefined'){
                        //     self[doc_name]['file_name'] = filesObj.get('file_name');
                        //     self[doc_name]['doc_url'] = res.data.documents.doc_url;
                        //     self[doc_name]['uuid'] = res.data.documents.uuid;
                        // } else {
                        //     if(typeof self.businessDocs[self.documentDefaultObj.user_type] == 'undefined'){
                        //         self.businessDocs[self.documentDefaultObj.user_type] = [];
                        //     }
                        //     // self.documentDefaultObj
                        //     self.documentDefaultObj['file_name'] = filesObj.get('file_name');
                        //     self.documentDefaultObj['doc_url'] = res.data.documents.doc_url;
                        //     self.documentDefaultObj['uuid'] = res.data.documents.uuid;
                        //     self.documentDefaultObj['folder_name'] = res.data.documents.folder_name;
                        //     self.documentDefaultObj['doc_name'] = res.data.documents.doc_name;
                        //     self.documentDefaultObj['size'] = res.data.documents.size;
                        //     self.documentDefaultObj['created_at'] = moment(res.data.documents.created_at).format("MMM DD, YYYY");

                        //     let newDefaultObj = Object.assign({},self.documentDefaultObj);
                        //     if(self.documentDefaultObj['document_type'] === 'others'){
                        //         self.otherDocs.push(newDefaultObj);
                        //     } else if(self.documentDefaultObj['document_type'] === 'business'){
                        //         self.businessDocs[self.documentDefaultObj.user_type].push(newDefaultObj);
                        //     }
                        // }
                        self._showToast(res.data.message);
                        // self.addMoreDocsForm['doc_name'] = '';
                        // self.$validator.reset('addMoreDocsForm'); 
                        self[self.currentDialogModel] = false;                        
                    } else {
                        self._showToast(res.data.message, "red");
                    }
                })
                .catch(err => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    self._showToast(err.message, "red");
                });

        },
        shareToEmail() {
            const self = this,
            wApp = window.getApp;
            
            let requestObj;
            let apiUrl;
            if(self.shareAll){
                let newObj = {};
                newObj.type = 'business';
                newObj.email = self.shareForm.email;
                requestObj = newObj;
                apiUrl = "documents/share-docs";
            } else {
                self.documentDefaultObj.email = self.shareForm.email;
                requestObj = self.documentDefaultObj;
                apiUrl = "documents/share-doc";
            }
            
            self.$validator.validateAll('shareWithEmail')
            .then(isValid => {
                if (isValid) {
                    wApp.$emit("showLoader", {
                        show: true
                    });
                    services.post(apiUrl, requestObj, 
                    {
                        Authorization: "Bearer " + this.$store.state.user.token
                    })
                    .then(res => {
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        if(!res.data.is_error){
                            self.inputEmailToShare = false;
                            self._showToast(res.data.message,config.successMsgColorStr);
                        } else {
                            self._showToast(res.data.message,config.errMsgColorStr);
                        }
                    })
                    .catch(err => {
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        self._showToast(err.message, config.errMsgColorStr);
                    });
                }
            });            
        },
        checkMultiShareDocValidation(docs){
            const self = this;
            if(docs && docs.length <= 0){
                self.multiDocValidationError = true;
                return true;
            } else {
                self.multiDocValidationError = false;
                return false;
            }
        },
        selectedBusinessDocsLink(){
            const self = this,
            wApp = window.getApp;
            if(!self.checkMultiShareDocValidation(self.selectedTruckerDocList)){
                
                // document.querySelector("#copy").addEventListener("click", self.clickEventCopyLink());
                let _secretKey = config.secretKeyForIncryption;
                let simpleCrypto = new SimpleCrypto(_secretKey);
                let tmpArr = []
                self.selectedTruckerDocList.map(function(data){
                    let tmpObj = {};
                    tmpObj.doc_url = data.doc_url;
                    tmpObj.doc_name = data.doc_name;
                    tmpObj.file_name = data.file_name;
                    tmpArr.push(tmpObj);
                })
                
                let encrypted = simpleCrypto.encrypt(tmpArr);
                // let urlComplete = config.downloadDocPublicUrl+'items='+encrypted;
                let urlComplete = config.downloadDocPublicUrl+'items='+encodeURIComponent(encrypted);
                
                bitly
                .shorten(urlComplete)
                .then(function(result) {
                    self.shareMultiUrl = result.url;
                    self.multiDocCopyToClipboardDialog = true;
                    
                    // document.querySelector("#copy").addEventListener("click", self.copy());
                    // setTimeout(function(val){
                        // document.getElementById("copy").addEventListener('click', () => self.copy());
                        // document.getElementById("copy").click();
                    //     // let aa1 = document.querySelector('#shareUrlSelectedInputId')
                    //     // aa1.setAttribute('type', 'text')
                    //     // aa1.select();
                    //     // document.execCommand("copy");
                    //     // aa1.setAttribute('type', 'hidden')
                    //     // self._showToast('Document url copied');
                    // },2000)
                })
                .catch(function(error) {
                    console.log(error)
                    self.shareMultiUrl = '';
                    self._showToast('Something is wrong, Please try again later', "red");
                });
                // self.shareMultiUrl = config.downloadDocPublicUrl+'items='+encodeURIComponent(encrypted);
            }
        },
        multiDocCopyToClipboard(){
            const self = this;
            let urlRef = document.querySelector('#shareUrlSelectedInputId')
            urlRef.setAttribute('type', 'text')
            urlRef.setAttribute('value', self.shareMultiUrl)
            urlRef.select();
            document.execCommand('copy');
            urlRef.setAttribute('type', 'hidden')
            urlRef.setAttribute('value', '')
            self._showToast('Document url copied');
        },
        shareSelectedToEmails() {
            const self = this,
            wApp = window.getApp;
            self.checkMultiShareDocValidation(self.selectedTruckerDocList);
                
            let tmpUuid = [];
            self.selectedTruckerDocList.map(function(val){
                tmpUuid.push(val.uuid)
            });
            let requestObj;
            let apiUrl;
            let newObj = {};

            newObj.type = 'business';
            newObj.email = self.multipleEmail.toString();
            newObj.uuid = tmpUuid.toString();
            newObj.message = self.shareMultiDocForm.message;
            requestObj = newObj;
            apiUrl = "documents/share-docmultiple";
            
            self.$validator.validateAll('shareMultipleDocsForm')
            .then(isValid => {
                if (isValid && !self.checkMultiShareDocValidation(self.selectedTruckerDocList)) {
                    wApp.$emit("showLoader", {
                        show: true
                    });
                    services.post(apiUrl, requestObj, 
                    {
                        Authorization: "Bearer " + this.$store.state.user.token
                    })
                    .then(res => {
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        if(!res.data.is_error){
                            self.shareSelectedBusinessDocsDialog = false;
                            self._showToast(res.data.message,config.successMsgColorStr);
                        } else {
                            self._showToast(res.data.message,config.errMsgColorStr);
                        }
                    })
                    .catch(err => {
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        self._showToast(err.message, config.errMsgColorStr);
                    });
                }
            });            
        },
        renameSubmit() {
            const self = this,
            wApp = window.getApp;
            
            self.$validator.validateAll('renameForm')
            .then(isValid => {
                if (isValid) {
                    wApp.$emit("showLoader", {
                        show: true
                    });
                    services.post('documents/rename',
                     {
                        doc_name:self.renameForm.name,
                        uuid: self.actionObj.uuid
                     }, 
                    {
                        Authorization: "Bearer " + this.$store.state.user.token
                    })
                    .then(res => {
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        if(res.data.status){
                            // if(self.actionObj.document_type == "business"){
                            //     self.businessDocs[self.actionObj.user_type][self.indexValue].doc_name = self.renameForm.name

                            // } else if(self.actionObj.document_type == "others"){
                            //     self.otherDocs[self.indexValue].doc_name = self.renameForm.name
                            // }
                            self.getDocumentList();  
                            self.renameDialog = false;
                            if(res.data.is_error==true){
                                self._showToast(res.data.message,config.errMsgColorStr);
                            }
                            else {
                                self._showToast(res.data.message,config.successMsgColorStr);
                            }
                        } 
                        else {
                            self._showToast(res.data.message,config.errMsgColorStr);
                        }
                    })
                    .catch(err => {
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        self._showToast(err.message, config.errMsgColorStr);
                    });
                }
            });            
        },
        newFolderDialog(document_type, file_type){
            const self = this;
            self.documentDefaultObj.document_type = document_type;
            self.documentDefaultObj.file_type = file_type;
            self.addNewFolder = true;
            self.currentDialogModel = 'addNewFolder';
        },
        folderClick(docObj) {
            const self = this;
            if(self.otherTabType == 'mydocuments'){
                self.getDocumentList(docObj);
            } else {
                self.getDocumentList(docObj);
            }
            self.folderLevel = 1;
        },
        displayDate(selectedDate, type) {
            if (this.documentDefaultObj.expiry_date && this.documentDefaultObj.expiry_date.length > 0) {
                return moment(selectedDate).format(config.displayDateFormat);
            }
            return '';
        },
        changePickerDate(type) {
            const self = this;
            let evt = document.createEvent("HTMLEvents");
            evt.initEvent("input", false, true);
            setTimeout(function () {
                document.getElementById(type + '_date').dispatchEvent(evt);
            }, 10)
        },
        businsDocTabs(type){
            const self = this;
            self.businsDocTabType = type;

        },
        determineDragAndDropCapable(){
            var div = document.createElement('div');
            return ( ( 'draggable' in div )
                    || ( 'ondragstart' in div && 'ondrop' in div ) )
                    && 'FormData' in window
                    && 'FileReader' in window;
        },
        async activateDragAndDrop(){
            if(this.addMoreDocs){
                this.dragAndDropCapable = await this.determineDragAndDropCapable();
                if( this.dragAndDropCapable ){
                    ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach( function( evt ) {
                        this.$refs.myFiles.addEventListener(evt, function(e){
                        e.preventDefault();
                        e.stopPropagation();
                        }.bind(this), false);
                    }.bind(this));
                    this.$refs.myFiles.addEventListener('drop', function(e){
                        this.onFileChange(e.dataTransfer.files);
                    }.bind(this));
                }
            }
        }
    }
};
</script>

<style lang="stylus">
.custom_table th,.custom_table td
  padding: 5px;
.v-list
  padding:0px;
.v-input--selection-controls__ripple, .v-input--selection-controls__input
  height:auto;
  width:auto;
.v-input--selection-controls
    margin-top: 0px; 
#labeluploadFile.v-btn--active:before, #labeluploadFile.v-btn:hover:before, #labeluploadFile.v-btn:focus:before
  background:none;
  cursor: pointer;
.upload-btn .v-btn
    padding: 0px
    max-height: 56px;
    min-height: 56px;
.inputfilebutton
    width: 100%;
    height: 100%;
    opacity: 0;
    position: absolute;
    cursor: pointer;
    left: 0;
    top: 0;
.fileIconInput
    width: 100%;
    text-align: center;
.v-btn.remove-border {
    border: none !important;
}
.bus_document_tab .v-window__container.v-window__container--is-active {
    height: auto !important;
}
table.v-datatable td {
    vertical-align: middle !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/documents/List.vue